var map = {
	"./box.svg": 4168,
	"./cd.svg": 1334,
	"./element-4.svg": 5366,
	"./folder-2.svg": 7069,
	"./gps.svg": 1731,
	"./location.svg": 1217,
	"./profile-circle.svg": 4570,
	"./routing.svg": 9494,
	"./tick-square.svg": 6137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3343;